import { createSlice } from "@reduxjs/toolkit";

const profiloSlice = createSlice({
  name: "profiloSlice",
  initialState: {
    firstName: "",
    lastName: "",
    email: "",
    role: "",
    token: "",
  },
  reducers: {
    setUserProfile: (_, action) => action.payload,
  },
});

export const { setUserProfile } = profiloSlice.actions;

export default profiloSlice.reducer;
